import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-subscribe' })

export class SubscribeComponent {
	constructor(private element: HTMLElement) {
		const target = element.getAttribute('data-target');
		const input = element.getElementsByTagName('input')[0];
		const trigger = element.getElementsByClassName('js-subscribe-button')[0] as HTMLElement;
		const mailField = document.getElementsByClassName('formemail')[0];
		const data = window.localStorage.getItem('data');

		trigger.addEventListener('click', (e) => {
			e.preventDefault();
			this.redirect(input.value, target);
		});

		// output all local storage
		// for (let i = 0; i < localStorage.length; i++) {
		// 	console.log(localStorage.getItem(localStorage.key(i)));
		// }

		if (input != null) {
			input.addEventListener('keyup', (event) => {
			if (event.keyCode === 13) {
				event.preventDefault();
				trigger.click();
			}
			});
		}

		if (data != null) {
			// get field and fill it up
			// console.log(data);
			if (mailField != null) {
				const mailFieldInput = mailField.getElementsByTagName('input')[0];
				mailFieldInput.value = data;
				window.localStorage.removeItem('data');
			}
		}
	}

	private redirect(data, target: string) {
		window.localStorage.setItem('data', data);
		window.location.href = target;
	}
}
